/**
 * Created by coolguy on 2017/11/10.
 */
import UserStore from "./UserStore";
import CommentStore from './CommentStore';
import MyStore from "./MyStore";
import UIStore from './UIStore';
import LocaleStore from './LocaleStore';
import VideoCommentStore from "./VideoCommentStore";
import BottomCommentStore from "./BottomCommentStore";
import RedPackStore from "./RedPackStore";
import GalleryStore from "./GalleryStore";
export  default class RootStore {
    constructor() {
        this.userStore = new UserStore(this);
        this.commentStore = new CommentStore(this);
        this.myStore = new MyStore(this);
        this.uiStore = new UIStore(this);
        this.localeStore = new LocaleStore(this);
        this.videoCommentStore = new VideoCommentStore(this);
        this.bottomCommentStore = new BottomCommentStore(this);
        this.redPackStore = new RedPackStore(this);
        this.galleryStore = new GalleryStore(this);
    }
}



// WEBPACK FOOTER //
// ./src/store/RootStore.js